import React, { Component } from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
	Button,
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	Form,
	FormGroup,
	FormInput,
	InputGroup,
	InputGroupAddon
} from 'shards-react';
import { addSectors, deleteItem } from '../adminActions';

const mapState = (state) => ({
	user: state.firebase.profile,
	sectors: state.firebase.ordered.sectors
});

const actions = {
	addSectors,
	deleteItem
};

class AddSector extends Component {
	state = {
		sector: ''
	};
	render() {
		const { sectors, deleteItem } = this.props;

		const handleChange = (e) => {
			this.setState({ [e.target.name]: e.target.value.toLowerCase() });
		};
		const handleSubmit = (e) => {
			e.preventDefault();
			this.props.addSectors(this.state.sector);
			this.setState({ sector: '' });
		};

		return (
			<Card>
				<CardHeader className="bg-primary1 text-white">Sectors</CardHeader>
				<CardBody className="category-list">
					{sectors &&
						sectors.map((sector) => {
							return (
								<div key={sector.id} className="text-capitalize w-100 caption">
									{sector.value}
									<MdClose
										className="float-right text-danger"
										onClick={() => deleteItem('sectors/', sector.key)}
									>
										Delete
									</MdClose>
								</div>
							);
						})}
				</CardBody>
				<CardFooter className="border-top">
					<Form>
						<FormGroup>
							<label htmlFor="username">Add Sector</label>

							<InputGroup>
								<FormInput name="sector" onChange={(e) => handleChange(e)} value={this.state.sector} />
								<InputGroupAddon type="append">
									<Button theme="success" disabled={this.state.sector === ''} onClick={handleSubmit}>
										Submit
									</Button>
								</InputGroupAddon>
							</InputGroup>
						</FormGroup>
					</Form>
				</CardFooter>
			</Card>
		);
	}
}

export default compose(connect(mapState, actions))(AddSector);
